import { Button, FormGroup, Offcanvas } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import React, { useCallback, useEffect, useRef } from "react";
import LiteTradePortfolio from "../../../modules/LiteTrade/components/LiteTradePortfolio/LiteTradePortfolio.jsx";
import MobileAccountBox from "../MobileAccountBox/MobileAccountBox.jsx";
import { BinIcon } from "../../../components/icon/Icon.jsx";
import { MobilePortfolioSelectAssetStyled } from "./styled/MobilePortfolioStyled.js";
import { MOBILE_SLIDER_PAGES_IDS } from "../MobileSliderPages/mobileSliderPagesConstants.js";
import { openMobileSliderPageAction } from "../../mobileAppActions.js";
import {
    getIsOpenRespawnBannerVisible,
    getUserSelectedAccountCode,
    getUserSelectedAccountType
} from "../../../app/appSelectors.js";
import { logAppsflyerAction, setIsOpenRespawnBannerVisibleAction } from "../../../app/appActions";
import { LOG_AF_EVENT_NAMES } from "../../../app/appConstants";
import { MobileRouterPaths } from "../../mobileAppConstants";
import appHistory from "../../../app/appHistory";
import LiteTradeSearchInput from "../../../modules/LiteTrade/components/LiteTradeSearchInput/LiteTradeSearchInput";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext";
import MobileWelcomeBanner from "../MobileBonusBanner/MobileWelcomeBanner";
import { getWelcomeBonusAvailable, getWelcomeBannerOpened } from "../../../modules/Bonus/bonusesSelectors";
import MobilePortfolioRespawn from "./MobilePortfolioRespawn";

function MobilePortfolio() {
    const prevAccountType = useRef(null);
    const {getLangPath} = useLangContext();

    const dispatch = useDispatch();
    const selectedAccountCode = useSelector(getUserSelectedAccountCode);
    const selectedAccountType = useSelector(getUserSelectedAccountType);
    const welcomeBannerOpened = useSelector(getWelcomeBannerOpened);
    const welcomeBonusAvailable = useSelector(getWelcomeBonusAvailable);
    const isOpenRespawnBannerVisible = useSelector(getIsOpenRespawnBannerVisible);

    useEffect(() => {
        if (selectedAccountType && !prevAccountType.current) {
            dispatch(logAppsflyerAction({
                name: LOG_AF_EVENT_NAMES.MAIN_SHOWN,
                payload: {account_type: selectedAccountType},
            }));
        }
        prevAccountType.current = selectedAccountType;
    }, [dispatch, selectedAccountType]);

    const handleSelectAsset = useCallback((e) => {
        e.preventDefault();
        dispatch(openMobileSliderPageAction(MOBILE_SLIDER_PAGES_IDS.ASSETS));
        dispatch(logAppsflyerAction({
            name: LOG_AF_EVENT_NAMES.MAIN_SELECT_ASSET,
            payload: {account_type: selectedAccountType, source: 'select'}
        }));
    }, [dispatch, selectedAccountType]);

    const handleSearchClick = useCallback(() => {
        appHistory.push(`${MobileRouterPaths.market}?focus-search=1`)
    }, []);

    const handleCloseRespawnBanner = useCallback(() => {
        dispatch(setIsOpenRespawnBannerVisibleAction(false));
    }, [dispatch]);

    return <>
        <h2 className={'mb-4'}>{getLangPath('lite_version.home.title')}</h2>
        <LiteTradeSearchInput onClick={handleSearchClick}/>

        {(!!welcomeBonusAvailable && welcomeBannerOpened) && <MobileWelcomeBanner className={'mt-3'} short/>}

        <FormGroup className={'mb-4 mt-3'}>
            <MobileAccountBox accountCode={selectedAccountCode}/>
        </FormGroup>

        <FormGroup className={'mb-4'}>
            <MobilePortfolioSelectAssetStyled>
                <Button variant={'primary'}
                        size={'lg'}
                        onClick={handleSelectAsset}
                >
                    <BinIcon name={'IcTransaction'}/> {getLangPath('lite_version.home.select_asset')}</Button>
            </MobilePortfolioSelectAssetStyled>
        </FormGroup>

        <LiteTradePortfolio/>

        <Offcanvas show={isOpenRespawnBannerVisible} placement="end" style={{width: "100%", background: 'unset'}}>
            <MobilePortfolioRespawn handleClose={handleCloseRespawnBanner}/>
        </Offcanvas>
    </>
}

export default MobilePortfolio;
